import { LastKnownUrlGuard } from '../../guards/last-known-url-guard/last-known-url-guard';
import { SessionStorageEntityIdResolver } from '../../resolvers/session-storage-entityid/session-storage-entityid.resolver';

export const districtPickerRoute = {
  path: 'district-picker',
  url: '/district-picker',
  canActivate: [
    LastKnownUrlGuard,
  ],
  authenticationRequired: true,
  resolve: {
    entityId: SessionStorageEntityIdResolver,
  },
  loadChildren: () => import('../../../shell/district-picker/district-picker.module').then(m => m.DistrictPickerModule),
};
